module.exports = __webpack_public_path__ + "media/application/assets/images/background_jumbotron_large-c49117737add1a7560b29e01def1e9cf.jpg";